// TanStack Query key factory for the message entity. Kept here so that
// future server-state mutations (e.g. an admin "ignore post" action) can
// invalidate without reaching into hook internals.

export const messageQueryKeys = {
  all: ["message"] as const,
  content: (communityId: string) =>
    [...messageQueryKeys.all, "content", communityId] as const,
} as const;
